import { render, staticRenderFns } from "./AIDisclaimer.vue?vue&type=template&id=121ebce8&scoped=true"
import script from "./AIDisclaimer.vue?vue&type=script&lang=js"
export * from "./AIDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./AIDisclaimer.vue?vue&type=style&index=0&id=121ebce8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121ebce8",
  null
  
)

export default component.exports